import React, { useEffect, useState} from 'react';

import { Divider, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ImageAvatar } from 'components/Avatar';
import { ListCard } from 'components/Card';

import { useAuth } from 'lib/auth';
import { paths } from 'routes';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import { IconWrapper } from 'components/Icon';

dayjs.extend(relativeTime);
dayjs.extend(utc);

const userTimeZone = dayjs.tz.guess();

const types = {
  framework_agreement: "Agreement",
  tender: "Tender",
  dps: "DPS",
}

export const HomeListItem = ({
  id,
  name,
  type,
  created_on,
  promoted,
  MainBuyer,
}) => {
  let url = paths.frameworkAgreementDetailsView(id);
  switch (type) {
    case 'tender':
      url = paths.tendersDetailsView(id);
      break;
    case 'dps':
      url = paths.dpsDetailsView(id);
      break;
  
    default:
      url = paths.frameworkAgreementDetailsView(id);
      break;
  }
  const { account, user } = useAuth();

  const adjustedDate = dayjs.utc(created_on).tz(userTimeZone, true);
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeAgo(adjustedDate.fromNow());
    }, 60000);

    setTimeAgo(adjustedDate.fromNow());

    return () => clearInterval(intervalId);
  }, [adjustedDate]);

  const clickable = () => {    
    if (account.super_admin || promoted || user.Company.is_premium) {
      return true;
    }

    return false;
  }
  
  
  return (
    <ListCard sx={{width: 1, py: 1.5, boxSizing: 'border-box'}}>
      <ImageAvatar img={MainBuyer?.square_logo_url || ''} name={MainBuyer?.Name || ''} />
      <Stack flex={{ md: 2, xl: 4 }} sx={{pr:1}} justifyContent="center">
        {clickable() ? (
          <Link
            component={RouterLink}
            to={url}
            color="inherit"
          >
            <Stack direction={'row'} gap={1}>
              <Typography variant="body1" fontWeight={700}>
                {name}
              </Typography>
              {promoted && (
                <IconWrapper
                  icon="rocket"
                  sx={({ palette }) => ({ svg: { width: 16, height: 16, stroke: palette.primary.main, color: palette.primary.main }, display: "flex" })}
                  height={16}
                  display={"flex"}
                  alignSelf={"center"}
                />
              )}
            </Stack>
          </Link>
        ) : (
          <Stack direction={'row'} gap={1}>
            <Typography variant="body1" fontWeight={700}>
              {name}
            </Typography>
            {promoted && (
              <IconWrapper
                icon="rocket"
                sx={({ palette }) => ({ svg: { width: 16, height: 16, stroke: palette.primary.main, color: palette.primary.main }, display: "flex" })}
                height={16}
                display={"flex"}
                alignSelf={"center"}
              />
            )}
          </Stack>
        )}
        <Stack direction="row" gap={1}>
          <Typography variant="caption" fontWeight={600}>
            {types[type]}
          </Typography>
          <Divider
            orientation="vertical"
            sx={{ borderColor: 'grey.500', height: 15, borderWidth: '1px' }}
          />
          {clickable() ? (
            <Typography variant="caption" color="text.primary" fontWeight={700}>
              <Link
                component={RouterLink}
                to={`/app/${MainBuyer?.Type}s/${MainBuyer?.company_id.toString()}`}
                color="inherit"
              >
                {MainBuyer?.Name}
              </Link>
            </Typography>
          ) : (
            <Typography variant="caption" color="text.primary" fontWeight={700}>
              {MainBuyer?.Name}
            </Typography>
          )}
        </Stack> 
      </Stack>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack justifyContent="center" sx={{pr:account.super_admin ? 1 : 0, width: 180}}>
        <Typography variant="caption" fontWeight={700}>
          Created
        </Typography>
      
        <Typography variant="body2" fontWeight={700}>
          {/* {isoToDateString(created_on, true)} */}
          {/* {formatLastSeen(created_on)} */}
          {timeAgo}
        </Typography>
      </Stack>
      </LocalizationProvider>
    </ListCard>
  );
};
